var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isLoggedIn)?_c('app-bar',{attrs:{"avatar":_vm.avatar,"nickname":_vm.nickname}}):_vm._e(),_c('v-content',[_c('v-container',[(_vm.isLoggedIn)?_c('router-view',{key:_vm.$route.fullPath}):_c('login-box')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }